import ICLICommand from "flow/interfaces/ICLICommand";

export default {
    name: "clear-history",
    description: "Clears command history",
    options: [],
    arguments: [],
    callback: (writer, optsAndArgs) => {
        optsAndArgs._commandHistory.clear();
        optsAndArgs._commandHistory.push("clear-history");
        writer.output.writeLine("History cleared");
        return { input: "" };
    }
} as ICLICommand;
